import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { installPhoneMaskDirective } from '@/utils/phoneMask'
import { installDruzhbaMetrica } from '@/analytics/metrica'
import { installDruzhbaMetricaV2 } from '@/analytics/metrica-v2'

Vue.config.productionTip = false
installPhoneMaskDirective(Vue)

require('vue-slick-carousel/dist/vue-slick-carousel.css')

import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

installDruzhbaMetrica({ router, store })
installDruzhbaMetricaV2({ router, store })




import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


// Изображения товара могут быть уже загружены браузером из prerendered HTML
// ещё до того, как Vue успеет навесить @load. Поэтому видимость изображения
// никогда не зависит от Vue-состояния, а skeleton синхронизируется также по
// img.complete/naturalWidth. Это закрывает зависшие skeleton после reload/back-cache.
const IMAGE_WITH_SKELETON_SELECTOR = [
  '.product-image-skeleton + img',
  '.product-story__skeleton + img',
  '.sofa-card__image-skeleton + img',
  '.landing-image-skeleton + img',
  '.favorite-card__image-skeleton + img',
  '.newcat-image-skeleton + img'
].join(',')

function revealLoadedImage(image) {
  if (!image || image.tagName !== 'IMG') return
  if (!image.matches(IMAGE_WITH_SKELETON_SELECTOR)) return
  if (!image.complete || image.naturalWidth <= 0) return

  image.style.removeProperty('display')
  image.style.opacity = '1'
  image.style.visibility = 'visible'

  const skeleton = image.previousElementSibling
  if (skeleton && String(skeleton.className || '').includes('skeleton')) {
    skeleton.style.display = 'none'
  }
}

function syncLoadedImages(root) {
  if (typeof document === 'undefined') return
  const scope = root && root.querySelectorAll ? root : document
  if (scope.tagName === 'IMG') revealLoadedImage(scope)
  const images = scope.querySelectorAll ? scope.querySelectorAll(IMAGE_WITH_SKELETON_SELECTOR) : []
  images.forEach(revealLoadedImage)
}

let imageSyncFrame = null
function scheduleLoadedImageSync() {
  if (typeof requestAnimationFrame === 'undefined') return
  if (imageSyncFrame) cancelAnimationFrame(imageSyncFrame)
  imageSyncFrame = requestAnimationFrame(() => {
    imageSyncFrame = null
    syncLoadedImages(document)
  })
}

if (typeof document !== 'undefined') {
  // capture=true ловит load у img, потому что обычный load не всплывает.
  document.addEventListener('load', event => revealLoadedImage(event.target), true)
  window.addEventListener('pageshow', scheduleLoadedImageSync)
  window.addEventListener('load', scheduleLoadedImageSync, { once: true })

  if (typeof MutationObserver !== 'undefined') {
    const imageObserver = new MutationObserver(scheduleLoadedImageSync)
    imageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    })
  }

  requestAnimationFrame(scheduleLoadedImageSync)
}

// В старой версии проекта регистрировался /service-worker.js, которого в проекте
// больше нет. Старый SW и Cache Storage могли продолжать отдавать устаревшие
// картинки/бандлы после обновления. Удаляем регистрацию и её кэши. Если текущая
// вкладка ещё контролировалась старым SW — один раз перезагружаем её уже без него.
if (typeof window !== 'undefined') {
  window.addEventListener('load', async () => {
    const hadController = Boolean('serviceWorker' in navigator && navigator.serviceWorker.controller)
    let removedRegistration = false

    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations()
        if (registrations.length) {
          removedRegistration = true
          await Promise.all(registrations.map(registration => registration.unregister()))
        }
      }
      if ('caches' in window) {
        const keys = await window.caches.keys()
        await Promise.all(keys.map(key => window.caches.delete(key)))
      }

      const reloadKey = 'druzhba-old-sw-cleanup-v2'
      if (hadController && removedRegistration && !window.sessionStorage.getItem(reloadKey)) {
        window.sessionStorage.setItem(reloadKey, '1')
        window.location.reload()
        return
      }
    } catch (error) {
      console.warn('Не удалось полностью очистить старый service worker/cache', error)
    }

    scheduleLoadedImageSync()
  }, { once: true })
}

const app = new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

router.afterEach(() => {
  scheduleLoadedImageSync()
})

// На product route браузер сначала видит только системный skeleton.
// Снимаем его лишь после того, как сам компонент товара уже отрисовал
// собственный skeleton или реальную карточку. Это исключает даже
// однокадровый показ старого/чужого bitmap при reload и восстановлении scroll.
if (typeof document !== 'undefined' && document.documentElement.classList.contains('product-boot')) {
  const startedAt = Date.now()
  const releaseProductBootCover = () => {
    const productReady = document.querySelector('.product-loading-page, .product-shell')
    if (!productReady && Date.now() - startedAt < 5000) {
      requestAnimationFrame(releaseProductBootCover)
      return
    }
    try { window.scrollTo(0, 0) } catch (_) {}
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.documentElement.classList.remove('product-boot')
        const cover = document.getElementById('product-boot-cover')
        if (cover && cover.parentNode) cover.parentNode.removeChild(cover)
      })
    })
  }
  requestAnimationFrame(releaseProductBootCover)
}

void app
